module.exports = __webpack_public_path__ + "img/gray.80716721.svg";